import { RootState } from '@reducers';

export const selectFeatureCar = (state: RootState) => state.featureCarReducer;
